<div id="show-student" class="row" *ngIf="learner">
  <div class="col-sm-3">
    <app-side-bar-guardian-home *ngIf="guardian"
    [guardian]="guardian"
    [target_student_user_id]="0">
  </app-side-bar-guardian-home>
  </div>
    <div class="col-sm-9">
        <app-nav-home-student [linkId]="1" [learner]='learner' [quiz_mode_name]="quiz_mode_name"></app-nav-home-student>
        <div class="card">
            <div class="card-header">
                <h4 >
                Hello {{learner.full_name}},  {{subscription.name}} {{subscription.level_name}} is calling ({{displayMode()}})
                <span  class="pull-right">
                <app-country-flag *ngIf="learner.server_student_id!=0" [countryImage]="learner.countryImage"></app-country-flag>
                </span>
                </h4>
                <app-score-summary *ngIf="learner.server_student_id!=0" [student]="learner"></app-score-summary>

           </div>
        <div class="card-body">
       <app-pending-quiz-list
        *ngIf="!loadingEnvelops"
        [server_student_user_id]="server_student_user_id"
        [data]="data"
        [quiz_mode_name]="quiz_mode_name">
        </app-pending-quiz-list>
         <app-spinner *ngIf="loadingEnvelops"></app-spinner>
        </div>
      </div>
    </div>


    <div class="row">
      <div class="col-sm-12">
        <app-spinner *ngIf="!maskedGift"></app-spinner>
        <app-student-gift-area *ngIf="(maskedGift && learner)" [maskedGift]="maskedGift" [learner]="learner"></app-student-gift-area>
    </div>
    </div>
    </div>
    <app-spinner *ngIf="!learner"></app-spinner>
